@use '@repo/sds/styles/tokens/mixins' as *;
.SDSIcon {
  display: flex;
  align-items: center;

  &__accessible-label {
    @include visually-hidden;
  }

  &--x-small {
    font-size: var(--size-icon-x-small);
  }

  &--small {
    font-size: var(--size-icon-small);
  }

  &--medium {
    font-size: var(--size-icon-medium);
  }

  &--big {
    font-size: var(--size-icon-big);
  }

  &--large {
    font-size: var(--size-icon-large);
  }

  &--x-large {
    font-size: var(--size-icon-x-large);
  }

  &--typing-text-regular {
    font-size: var(--size-icon-typing-text-regular);
  }

  &--icons {
    font-size: var(--size-footer-icons);
  }

  @include semantic-colors;
  @include role-status-colors;

  &--chip-checkmmark {
    color: var(--background-chip-checkmmark);
  }
}
